import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import referenceService from "../service-api/referenceService";

// Initial state
const initialState = {
  data: [],
  activeRoles: [],
  error: null,
  isLoading: true,
  isFormSubmitting: false,
};

export const fetchReferenceByCandidateID = createAsyncThunk(
  "data/fetchReferenceByCandidateID",
  async (id) => {
    const response = await referenceService.fetchReferenceByCandidateID(id);
    return response.data;
  }
);

export const updateReference = createAsyncThunk(
  "data/updateReference",
  async ({ id, formData }) => {
    const response = await referenceService.updateReference(id, formData);
    return response.data;
  }
);

export const addReference = createAsyncThunk(
  "data/addReference",
  async (obj) => {
    const response = await referenceService.addReference(obj);
    return response.data;
  }
);

export const deleteReference = createAsyncThunk(
  "data/deleteReference",
  async (id) => {
    const response = await referenceService.deleteReference(id);
    return response.data;
  }
);

// Create slice
const referenceSlice = createSlice({
  name: "role",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchReferenceByCandidateID.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchReferenceByCandidateID.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.value;
      })
      .addCase(fetchReferenceByCandidateID.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(updateReference.pending, (state) => {
        state.isFormSubmitting = true;
      })
      .addCase(updateReference.fulfilled, (state, action) => {
        state.isFormSubmitting = false;
      })
      .addCase(updateReference.rejected, (state, action) => {
        state.isFormSubmitting = false;
        state.error = action.error.message;
      });

    builder
      .addCase(addReference.pending, (state) => {
        state.isFormSubmitting = true;
      })
      .addCase(addReference.fulfilled, (state, action) => {
        state.isFormSubmitting = false;
      })
      .addCase(addReference.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(deleteReference.pending, (state) => {
        state.isFormSubmitting = true;
      })
      .addCase(deleteReference.fulfilled, (state, action) => {
        state.isFormSubmitting = false;
      })
      .addCase(deleteReference.rejected, (state, action) => {
        state.isFormSubmitting = false;
        state.error = action.error.message;
      });
  },
});

export default referenceSlice.reducer;
